
interface iCalificacionBoton{
    idProducto: number,
    productos: any,
    save: any,
    calificaciones: any,
    onClick : any,
}
export default function CalificacionBoton(props: iCalificacionBoton){
    const prod = props?.productos?.filter((item:any) => item.id === props.idProducto);
    const prod1 = prod[0];
    //console.log("Productos filtered:", prod1);


    const getCalificacion = () => {
        //console.log("idProducto:", idProducto);
        console.log("calificaciones:", props?.calificaciones);
        //TODO: creo que no debo buscar x idProdcuto ya que puedo comprarle 2 veces al mismo.
        if ( props?.calificaciones?.length == 0) return "";

        const cal = props?.calificaciones.find((item: any) => item.idProducto == prod1?.id);
        console.log("cal: ", cal);
        
        if ( cal === undefined) {
            console.log("undefined cal");
            return "";
        }else{
            console.log("calificaciones y producto:", cal.voto , "prod: ", prod1?.titulo);
            console.log("calidPRod:", cal.idProducto , " voto:", cal.voto ," prodId:", prod1.id, " titulo:", prod1.titulo)
            return cal.voto;
        }
        
    }

    const IconoCalificacion = (calif: any) =>{
        console.log("IconoCalif:", calif.calif , " ", prod1?.titulo, " pid:", prod1?.id);
        console.log("Tipeof calif voto:", typeof calif.calif, " ", calif.calif);
        let asString = "";
        let asNumber = -1;

        if ( typeof (calif.calif) === "number"){
            asNumber = parseInt(calif.calif);
            asString= "nulo";
        }else{
            asNumber = -1;
            asString = calif.calif;
        }

        if ( asString == "") return <button className="btnNormal" onClick={() => {
                    if ( props?.onClick){
                        props?.onClick(props?.save);
                    }
                }}>Calificar</button>;
        else{
            switch(asNumber){
                case 0: 
                    return <p>Neutral</p>;
                case 1: 
                    return <p>Positivo</p>;
                case -1: 
                    return <p>Negativo</p>
                default: 
                    return <p>Error</p>;
            }
        }
    }


    //console.log("Calificacionboton >> save:", props?.save);
    const diff = diff2Dates((new Date()).toString(), props?.save?.fecha);
    if ( diff >= 1){
        console.log("producto:", prod1);
        return <IconoCalificacion calif={ getCalificacion()} />;    
    }
    //menos de 1 dia
    return <></>
    
}



function diff2Dates(strFecha1: string, strFecha2: string){
    const fecha1 = new Date(strFecha1);
    const fecha2 = new Date(strFecha2);
    //const differenceInMsExplicit = fecha2.getTime() - fecha1.getTime(); 
    const msPerDay = 1000 * 60 * 60 * 24;
    const differenceInDays = Math.round(Math.abs(fecha2.getTime() - fecha1.getTime()) / msPerDay);

    console.log("Differencia dias:", differenceInDays);
    return differenceInDays;
}